import { cloneDeep, merge } from 'lodash'
import { StateCreator } from 'zustand'

import { TCampaign, TCampaignListItem } from '~/features/campaigns/models'

type TCampaignsDefinition = {
  allCampaigns: TCampaignListItem[] | null
  selectedCampaign: TCampaign | null
}

type TCampaigns = {
  campaigns: TCampaignsDefinition
}

export type TCampaignsState = TCampaigns & {
  setCampaigns(campaigns: Partial<TCampaignsDefinition>): void
}

export const initialCampaignsState: TCampaignsDefinition = {
  allCampaigns: [],
  selectedCampaign: null,
}

const createCampaignsSlice: StateCreator<
  TCampaignsState,
  [['zustand/devtools', unknown]],
  []
> = (set) => ({
  campaigns: cloneDeep(initialCampaignsState),
  setCampaigns: (campaigns) =>
    set(
      (state) => ({
        campaigns: cloneDeep(merge(state.campaigns, campaigns)),
      }),
      undefined,
      {
        type: 'setCampaigns',
        campaigns,
      },
    ),
})

export default createCampaignsSlice
